import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { InputNumber } from 'primeng/inputnumber';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'input-field',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FloatLabelModule,
    InputTextModule,
    MessageModule,
    InputNumber,
    TranslatePipe
  ],
  templateUrl: './input-field.component.html',
})
export class InputFieldComponent {
  type = input<'text' | 'number' | 'email' | 'tel' | 'date'>('text');
  control = input.required<FormControl>();
  label = input.required<string>();
  name = input<string>();
  numberPrice = input<boolean>(false);
  readonly = input<boolean>(false);
}
